interface IModalNav {
  step: number;
  setAnyStep: Function;
}

function ModalNav(props: IModalNav) {
  const { step, setAnyStep } = props;

  const renderCheckCircle = (stepToCheck: number) => {
    if (step > stepToCheck) {
      return (
        <i
          className="fas fa-check-circle checked-footer-icon"
          style={{ color: "#07b860" }}
        ></i>
      );
    }
    return null;
  };

  return (
    <>
      <div className="footer-navigation-pill box-shadow">
        <div className="position-static text-center h-100 d-flex justify-content-center align-items-center">
          <div
            className={step === 1 ? "active-footer-icon relative" : "relative"}
          >
            <i
              className={
                step > 1 ? "fas fa-check-circle checked-footer-icon" : ""
              }
              style={{ color: "#07b860" }}
            ></i>
            <div
              className="footer-icon-wrapper d-flex justify-content-center align-items-center hoverable"
              onClick={() => setAnyStep(1)}
            >
              <i className="fas fa-keyboard"></i>
            </div>
            <p className="footer-icon-text">Inputs</p>
          </div>
          <i className="fas fa-long-arrow-alt-right footer-arrow"></i>
          <div
            className={step === 2 ? "active-footer-icon relative" : "relative"}
          >
            <i
              className={
                step > 2 ? "fas fa-check-circle checked-footer-icon" : ""
              }
              style={{ color: "#07b860" }}
            ></i>
            <div
              className="footer-icon-wrapper d-flex justify-content-center align-items-center hoverable"
              onClick={() => setAnyStep(2)}
            >
              <i className="fas fa-balance-scale"></i>
            </div>
            <p className="footer-icon-text">Compare</p>
          </div>
          <i className="fas fa-long-arrow-alt-right footer-arrow"></i>
          <div
            className={step === 3 ? "active-footer-icon relative" : "relative"}
          >
            <i
              className={
                step > 3 ? "fas fa-check-circle checked-footer-icon" : ""
              }
              style={{ color: "#07b860" }}
            ></i>
            <div
              className="footer-icon-wrapper d-flex justify-content-center align-items-center hoverable"
              onClick={() => window.parent.open("/configurator/configurator/selection/", "_blank")}
              >
              <i className="fas fa-wrench"></i>
            </div>
            <p className="footer-icon-text">Configure</p>
          </div>
          <i className="fas fa-long-arrow-alt-right footer-arrow"></i>
          <div
            className={step === 4 ? "active-footer-icon relative" : "relative"}
          >
            <i
              className={
                step > 4 ? "fas fa-check-circle checked-footer-icon" : ""
              }
              style={{ color: "#07b860" }}
            ></i>
            <div
              className="footer-icon-wrapper d-flex justify-content-center align-items-center hoverable"
              onClick={() => window.parent.open("/configurator/configurator/selection/", "_blank")}
              >
              <i className="fas fa-receipt"></i>
            </div>
            <p className="footer-icon-text">Quote</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModalNav;
